import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroFattureVenditaModalComponent } from './worker-registro-fatture-vendita-modal';

export const WorkerRegistroFattureVenditaModalModule: string = ng
    .module('worker-registro-fatture-vendita-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroFattureVenditaModalComponent', WorkerRegistroFattureVenditaModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-fatture-vendita-modal/worker-registro-fatture-vendita-modal.module.ts